import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    sectionTitle: {
        fontSize: "18px !important",
        fontWeight: 400,
        color: theme.palette.info.main,
        marginBottom: theme.spacing(8),
    },
    card: {
        background: `${theme.palette.primary.main} !important`,
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15) !important",
        borderRadius: "4px !important",
        "&::before": {
            content: "none !important",
        },
        "& .Mui-expanded": {
            minHeight: "0 !important",
        },
    },
    cardHeader: {
        padding: `${theme.spacing(3)} ${theme.spacing(4)} !important`,
        display: "flex !important",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: `1px solid ${theme.palette.border.select} !important`,
        "& .MuiAccordionSummary-content": {
            alignItems: "center !important",
            margin: "0 !important",
            gap: theme.spacing(2),
        },
    },
    cartTitleContainer: {
        display: "flex",
        alignItems: "center",
    },
    cardTitle: {
        fontSize: "18px !important",
        fontWeight: 400,
        fontFamily: "Source Sans 3",
        color: theme.palette.info.main,
    },
    cardBody: {
        display: "flex",
        flexDirection: "column",
        position: "relative",
        alignItems: "center",
        padding: `${theme.spacing(4)} ${theme.spacing(2)}`,
    },
    cardBodyContent: {
        padding: "14px 14px 4px 14px",
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(3.5),
    },
    cardHeaderIcon: {
        transition: "all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important",
    },
    tableHeader: {
        padding: `${theme.spacing(3)} ${theme.spacing(4)} !important`,
        display: "flex !important",
        alignItems: "center",
        justifyContent: "space-between"
    },
    table: {
        width: "calc(100% - 28px)",
        borderCollapse: "collapse",
        borderTop: `1px solid ${theme.palette.border.select}`,
        margin: `0px ${theme.spacing(3)}`,
    },
    thTd: {
        padding: '15px',
        textAlign: "left",
        borderBottom: `1px solid ${theme.palette.border.select}`,
        verticalAlign: "middle",
        color: theme.palette.primary.darker,
        fontSize: 14,
        fontWeight: 400,
        fontFamily: "Source Sans 3",
    },
    thTdHighlighted: {
        padding: '15px',
        textAlign: "left",
        borderBottom: `1px solid ${theme.palette.border.select}`,
        verticalAlign: "middle",
        textDecoration: 'underline',
        color: theme.palette.info.main,
        fontSize: 14,
        fontWeight: 700,
        fontFamily: "Source Sans 3",
        cursor: 'pointer'
    },
    th: {
        padding: '5px 10px',
        color: theme.palette.primary.dark,
        fontSize: 12,
        fontWeight: 700,
        fontFamily: "Source Sans 3",
        textTransform: "uppercase",
        borderBottom: `1px solid ${theme.palette.border.select}`,
    },
    tfootTd: {
        color: theme.palette.primary.darker,
        fontSize: 14,
        fontWeight: 600,
        fontFamily: "Source Sans 3",
        textTransform: "uppercase",
        padding: '15px 17.5px',
        textAlign: "left",
        verticalAlign: "middle",
    },
    userNameContainer: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        color: theme.palette.primary.darker,
        fontSize: 14,
        fontWeight: 400,
        fontFamily: "Source Sans 3",
    },
    userImage: {
        borderRadius: "50%",
        width: "22px",
        height: "22px",
        objectFit: 'cover'
    },
    noData: {
        color: theme.palette.primary.darker,
        fontSize: 14,
        fontWeight: 600,
        fontFamily: "Source Sans 3",
        textTransform: "uppercase",
        padding: '15px 17.5px',
        textAlign: "center",
        verticalAlign: "middle",
    },
}));